export default __webpack_public_path__ + "static/media/madame_detail18.6aa9bc28.jpg";